type Props = {
  title: string
  milestone: string
}

/**
 * Placeholder reutilizable mientras las páginas reales se implementan.
 * Identifica visualmente qué milestone la entregará.
 */
export function Placeholder({ title, milestone }: Props) {
  return (
    <section className="placeholder">
      <h1>{title}</h1>
      <p>
        Esta sección se implementa en el <strong>{milestone}</strong>.
      </p>
    </section>
  )
}
